// extracted by mini-css-extract-plugin
export var chatHtmlText = "_p3-2";
export var chatLink = "_p3-0";
export var chatText = "_p3-1";